import React from 'react';
import { Placeholder } from '@components/basics/Placeholder';
import { Plus3D } from '@components/icons/Illustrations/plus3d';

export function EmptyState() {
  return (
    <Placeholder
      illustration={<Plus3D />}
      subHeading={"It's a bit quiet in here"}
      text="Wait for the channel owner to create some awesome content!"
      buttonLabel="Go to Home"
      href="/"
      mainFeed
    />
  );
}
